import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { AUTH_REDIRECT_SEARCH_PARAM } from "../../common/constants";
import { SessionProvider, useIsAuthenticated } from "../../modules/auth/hooks";
import { AUTH_ROUTE_PATHS } from "../../modules/auth/paths";
import { endSession, sessionQueryOptions } from "../../modules/auth/session";
import { DASHBOARD_ROUTE_PATHS } from "../../modules/dashboard/paths";

export const ProtectedRoute = () => {
  const location = useLocation();

  const isUserAuthenticated = useIsAuthenticated();
  // The only enabled observer - it loads the session and keeps the token refreshed.
  const { data: session, isLoadingError } = useQuery({ ...sessionQueryOptions(), enabled: isUserAuthenticated });

  // Pages need the permissions from the session, so a session that fails to load logs the user out.
  useEffect(() => {
    if (isLoadingError) {
      endSession();
    }
  }, [isLoadingError]);

  if (!isUserAuthenticated) {
    const redirectParam =
      location.pathname !== DASHBOARD_ROUTE_PATHS.homepage.to
        ? `?${AUTH_REDIRECT_SEARCH_PARAM}=${encodeURIComponent(location.pathname + location.search)}`
        : "";

    return <Navigate replace to={AUTH_ROUTE_PATHS.login.to + redirectParam} />;
  }

  if (!session) {
    return <Spin spinning fullscreen size="large" />;
  }

  return (
    <SessionProvider value={session}>
      <Outlet />
    </SessionProvider>
  );
};
